import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { Paths } from 'shared/routes/paths';
import { User } from 'shared/types/user';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

// Single owner of the "where does the app land when it opens with a signed-in user" decision.
export const getAppOpenPath = (options?: {
  onboardingPremium?: boolean;
}): string =>
  options?.onboardingPremium
    ? replaceUrlParams(
        Paths.Home,
        {},
        { [QueryParamOptions.OnboardingPremium]: 'true' },
      )
    : Paths.Home;

export const useNavigateAppOpenScreen = () => {
  const navigate = useNavigate();

  return useCallback(
    (user: User | null) => {
      if (user) {
        navigate(getAppOpenPath());
      }
    },
    [navigate],
  );
};
